// extracted by mini-css-extract-plugin
module.exports = {"dot":"styles_dot__2W5d1","spinner":"styles_spinner__1dC-A"};